import { render, staticRenderFns } from "./TxtCardWidget.vue?vue&type=template&id=40e73c34&scoped=true&"
import script from "./TxtCardWidget.vue?vue&type=script&lang=ts&"
export * from "./TxtCardWidget.vue?vue&type=script&lang=ts&"
import style0 from "./TxtCardWidget.vue?vue&type=style&index=0&id=40e73c34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e73c34",
  null
  
)

export default component.exports